import {CheckCircleOutline} from '@mui/icons-material';
import { Modal, Tooltip } from 'antd';
import { useFirebase } from 'containers/FirebaseContext';
import { useGetRedirectUrlForBook } from 'containers/hooks';
import {
    collection,
    onSnapshot,
    query,
    updateDoc,
    where
} from 'firebase/firestore';
import { get, some } from 'lodash';
import React, { useEffect, useState } from 'react';
import { useLocation, useNavigate } from "react-router-dom";
import { handleGetActivityById } from 'store/activities/thunks';
import { useAllBook } from 'store/books/selectors';
import { useCurrentClassBook } from 'store/classes/selectors';
import styled from "styled-components";
import COLOR from "utils/constants/color";
import * as Sentry from "@sentry/react";
import { useDispatch } from 'react-redux';
import { handleListStoryAiConfig } from 'store/StoryAiCofig/thunks';
import { handleListWorkSheet } from 'store/worksheet/thunks';
import { useConfirm } from './UI/confirmProvider';


const Text = styled.span`
  color: ${COLOR.black500};
  font-size: 11px;
  margin-top: 2px;
  text-align: left;
`

export default function AssignableSharePopup({ currentClass, currentUser, onGetAssignment = () => { }, onNoData = () => { } }) {
    const location = useLocation();
  	const navigate = useNavigate();
    const booksAllList = useAllBook()
    const { firestore } = useFirebase();
    const currentClassBookList = useCurrentClassBook()
    const [openModal, setOpenModal] = useState(false);
    const [notificationData, setNotificationData] = useState([])
    const [showNotification, setShowNotification] = useState([]);
    const {redirectToBook} = useGetRedirectUrlForBook();
    const dispatch = useDispatch();
    const confirm = useConfirm()

    useEffect(() => {
        // const unsubscribe = listenToNotificationData(get(currentClass, 'id', ''));
        // return () => {
        //     unsubscribe();
        // };
    }, [firestore, currentClass])

    const listenToNotificationData = () => {
        const collectionRef = collection(firestore, "share_notifications");
        const q = query(collectionRef,
            where("createdBy", "!=", currentUser.id),
            where("notification_list", "array-contains", currentUser.id)
        );
        const unsubscribe = onSnapshot(q, (querySnapshot) => {
            const notifications = [];
            querySnapshot.forEach((doc) => {
                notifications.push({ id: doc.id, ...doc.data() });
            });
         
            if (notifications?.length > 0) {
                setOpenModal(true);
                setNotificationData(notifications)
                setShowNotification(notifications)
            }
        }, (error) => {
            console.error("Error listening to session changes:", error);
        });

        return unsubscribe;
    };

    const onDeleteNotification = async (deleteData) => {
        const collectionRef = collection(firestore, "share_notifications");
        const q = query(collectionRef, where("notification_list", "array-contains", currentUser.id), where("id", "==", deleteData?.id));
        const unsubscribe = onSnapshot(q, (querySnapshot) => {
            querySnapshot.forEach((doc) => {
                const data = doc.data();
                const idIndex = data.notification_list.indexOf(currentUser.id);
                if (idIndex !== -1) {
                    data.notification_list.splice(idIndex, 1);
                    updateDoc(doc.ref, { notification_list: data.notification_list })
                        .then(() => {
                            onGetAssignment()
                            // setOpenModal(false)
                        })
                        .catch((error) => {
                            console.error("Error updating document: ", error);
                            Sentry.captureException(`140 Error updating document: ${error}`);
                        });
                }
            });
        }, (error) => {
            console.error("Error listening to session changes:", error);
        });

        return unsubscribe;
    }

    const onView = async (activityData) => {
      // for story share
      try {
        const notificationChapter = activityData?.chapter || activityData?.bookId;
        const notificationPage = activityData?.page || activityData?.pageId;
        const params = new URLSearchParams(window.location.search);
        const currentChapter = params.get("chapter") || "";
        const currentPage = params.get("page") || "";
        
        const isSamePage = Number(currentChapter) === Number(notificationChapter) && 
                          Number(currentPage) === Number(notificationPage);
        
        if (activityData?.url) {
          const isEbookPath = [
            "/ebook",
            "/balconCulturalBook",
            "/stories",
            "/video",
          ].some((path) => location.pathname.includes(path));

          if (isEbookPath) {
            dispatch(
              handleListStoryAiConfig(
                {
                  chapter: activityData?.data?.chapter,
                  user_id: currentUser?.id,
                  class_id: activityData?.data.class_id,
                },
                currentUser?.role === "student"
              )
            );
          }
          
          if (activityData?.data?.assignmentType === 'worksheet') {
            if (isSamePage && currentUser?.id) {
              await dispatch(handleListWorkSheet(notificationChapter, currentUser?.role, currentUser?.id, 100, 0, true, null, currentClass?.id));
            }
            onGetAssignment();
          }
          
          if (isSamePage && activityData?.data?.assignmentType === 'worksheet') {
            window.location.reload();
          } else {
            navigate(activityData?.url);
          }
          onDeleteNotification(activityData);
          return;
        }
        let url;
        if (activityData?.data?.assignmentType === 'worksheet') {
          url = redirectToBook({
            chapter: notificationChapter,
            page: notificationPage
          });
        } else {
          url = redirectToBook(activityData);
        }

        const getActivityExist = await handleGetActivityById(activityData?.id);
        if (getActivityExist?.length === 0) {
          onNoData("Assignment not found!");
        }
        
        if (activityData?.data?.assignmentType === 'worksheet') {
          if (isSamePage && currentUser?.id) {
            await dispatch(handleListWorkSheet(notificationChapter, currentUser?.role, currentUser?.id, 100, 0, true, null, currentClass?.id));
          }
          onGetAssignment();
        }
        
        onDeleteNotification(activityData);
        if (currentChapter) {
          if (isSamePage) {
            window.location.reload();
          } else {
            navigate(url);
          }
        } else {
          navigate(url);
        }
        destroyAll();
      } catch (error) {
        Sentry.captureException(error);
        console.log(error);
        Sentry.captureException(`141 Error in onView: ${error}`);
      }
    };



    const destroyAll = () => {
        Modal.destroyAll();
    };
    const showConfirm = (obj) => {
        const checkId = showNotification.some(item => item.id === obj.id);
        if (!checkId) return;
        const checkExistBook = currentClassBookList.some(bookId => bookId == obj.bookId);
        const booksNotAssignableIds = booksAllList.filter(b => b.isNotAssignable).map(book => `${book.id}`);
        const checkNonAssignableBook = some(booksNotAssignableIds, (book) => book === obj?.bookId);
       if (!checkExistBook && !checkNonAssignableBook && !obj?.resourceType && obj?.checkBookExist) {
            onDeleteNotification(obj)
            return;
        } else {
            confirm({
                icon: null,
                content: (
                    <Text style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                        <CheckCircleOutline style={{ color: '#83ce34', fontSize: 50, marginRight: 6 }} />
                        <Tooltip title={obj?.message}>
                         <strong style={{ fontSize: 16, fontWeight: 500, color: 'black' }} className='text-wrap'>{obj.message}</strong>
                        </Tooltip>
                        {/* <Button onClick={destroyAll}>Click to destroy all</Button> */}
                    </Text>
                ),
                okText: 'View',
                cancelText: 'Cancel',
                onOk() {
                    onView(obj)
                },
                onCancel() {
                    onDeleteNotification(obj)
                },
            });
        }
    };

    useEffect(() => {
        if (notificationData.length > 0) {
            const displayNotification = (index) => {
              if (index < notificationData.length) {
                showConfirm(notificationData[index]);
                setTimeout(() => {
                  displayNotification(index + 1);
                }, 500);
              }
            };
      
            displayNotification(0);
          }
    }, [notificationData]);

    return null;
}
